import {
  GET_CLIENT_DETAIL_DATA,
  GET_CLIENT_DETAILS_PAGINATOR,
  SET_CLIENT_CARE_ACTIVITY_SELECTED_ITEMS,
  SET_CLIENT_DETAIL_DATA,
  SET_CLIENT_DETAILS_PAGINATOR,
  SET_CLIENT_LIST_DATA,
} from '@stores/client/constans.js';

export const initialState = {
  clientList: {},
  clientDetail: {},
  policyListForClient: {},
};

const clientReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_CLIENT_LIST_DATA:
      state = {
        ...state,
        clientList: payload,
      };
      break;
    case SET_CLIENT_DETAIL_DATA:
      state = {
        ...state,
        clientDetail: payload,
      };
      break;
    case SET_CLIENT_DETAILS_PAGINATOR:
      state = {
        ...state,
        policyListForClient: payload,
      };
      break;
    case SET_CLIENT_CARE_ACTIVITY_SELECTED_ITEMS:
      state = {
        ...state,
        clientCareActivitySelectedItems: payload,
      };
      break;
    default:
      break;
  }
  return state;
};
export default clientReducers;
